import { createSelector } from '@reduxjs/toolkit';
import { findEntity, selectEntities, selectForDevice, selectThermometerEntitiesFromSlice } from './entitiesSlice';
export const selectSensors = createSelector([selectEntities, (state) => state.definitions.devices
], (entities, devices) => {
    const res = [];
    const termEntities = selectThermometerEntitiesFromSlice(entities);
    for (const te of termEntities) {
        const d = devices[te.device_id];
        if (d != undefined) {
            const deviceEntities = selectForDevice(entities, d.id);
            const humid = findEntity(deviceEntities, 'humidity');
            res.push({
                device: d,
                temp: te,
                humid: humid
            });
        }
    }
    return res.sort((a, b) => {
        return a.device.title.localeCompare(b.device.title);
    });
});
